import { queries } from 'RestAPIs/rapini';

export const useGetDayLimitArrangements = (employeeId: number) => {
  return queries.useGetDayLimitArrangementsForEmployee(employeeId);
};

export default useGetDayLimitArrangements;
